export default __webpack_public_path__ + "static/media/coins3.42f550e0.mp3";